<template>
    <div v-if="loading" class="text-center">
        <v-progress-circular
        color="primary"
        indeterminate
        rounded
        height="6"
        v-show="loading || saving"
    ></v-progress-circular>
    </div>
    <div v-else @click.stop="show" class="pointer">
        <slot ></slot>
        <v-dialog v-model="display" max-width="1200" transition="dialog-bottom-transition" persistent>
            <v-card outlined class="modern-card overflow-hidden">
                <detail 
                    v-if="workOrderOnDisplay"
                    :loading="loading" 
                    :work_order.sync="workOrderOnDisplay" 
                    @close="display=false"
                    :key="workOrderVersion"
                /> 
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { getWorkOrder } from "@/api/production";
import WorkOrderCard from '@/components/production/WorkOrderCard'
import Detail from './workorder/Detail'
import notifications from "@/utils/notifications";
export default {
    name:'ShowWorkOrder',
    components:{Detail},
    props:['work_order_id'],
    data() {
        return {
            loading:false,
            workOrderOnDisplay:null,
            display:false,
            workOrderVersion: 0
        }
    },
    watch: {
        workOrderOnDisplay: {
            handler() {
                // Cada vez que el objeto cambia (por sync o refresh), incrementamos la versión
                // para forzar el re-render total del árbol de componentes hijos si Vue se pierde
                this.workOrderVersion++
            },
            deep: false // Solo queremos re-render si el objeto raíz cambia (que es lo que hace el sync)
        }
    },
    methods:{
        show(){
            this.loading=true
            getWorkOrder(this.work_order_id).then(response=>{
                this.workOrderOnDisplay=response
                //mostrar los productos ordenados por sales_note_key
                this.workOrderOnDisplay.products.sort((a,b)=>a.sales_note_key-b.sales_note_key)
                this.loading=false
                this.display=true
            }).catch(error=>{
                this.loading=false
                notifications.showError(error)
            })
        },
    }
}

</script>

<style>
  .pointer{
    cursor: pointer;
  }

</style>
